import Vue from 'vue'
import Feedback from './Feedback.vue'
import store from '@/store'
import config from '@/mixins/componentConfiguration'
import commonConfig from '@/mixins/commonMixin'

window.vm3 = new Vue({
  store,
  mixins: [commonConfig(Vue), config(Vue)],
  render: h => h(Feedback)
}).$mount('#feedback')
